/*
 * Copyright (c) 2025 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Filter Icon component.
 */
export const FilterIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='FilterIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <g transform='translate(3,3)'>
          <path d='M12.6003 4.70686C12.7807 4.37371 12.5395 3.96875 12.1606 3.96875H2.8394C2.46053 3.96875 2.21931 4.37371 2.39974 4.70686L5.46531 10.3674C5.5049 10.4405 5.52564 10.5224 5.52564 10.6055V13.3784C5.52564 13.5977 5.66857 13.7914 5.87812 13.8561L8.83389 14.7688C9.15552 14.8681 9.48141 14.6277 9.48141 14.2911V10.4814C9.48141 10.48 9.48023 10.4788 9.47878 10.4788V10.4788C9.47678 10.4788 9.47551 10.4767 9.47646 10.4749L12.6003 4.70686Z' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
        </g>
      </svg>
    )} />
  );
};

export default FilterIcon;
